<template>
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon">
          <i v-if="$route.path == '/power'" class="metismenu-icon pe-7s-power icon-gradient bg-mean-fruit"> </i>
          <i v-if="$route.path == '/tv'" class="pe-7s-monitor icon-gradient bg-mean-fruit"> </i>
          <i v-if="$route.path == '/data'" class="metismenu-icon pe-7s-global icon-gradient bg-mean-fruit"> </i>
        </div>
        <div>
          <strong>{{ name }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    name() {
      return this.$route.name;
    }
  },
  methods: {}
};
</script>
<style scoped></style>
